
import React, { useEffect, useState } from 'react';
import { isNumeric, isMonthAndYearEmpty, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading'


function AnnualAgriculturalProductionDetailsData({
    userInfoObject,
    yearName,
    reportType,
    annualAgrilcultureData,
    resetFormData,
    refreshAnnualAgricultureData,
    config,
    payload


}) {

    const navigate = useNavigate();
    const [itemData, setItemData] = useState({});
    const {
        isSaveBtnDisable,
        isSubmitBtnDisable,
        isAcceptBtnDisable,
        isRejectBtnDisable
    } = getButtonDisabledStates(payload, userInfoObject);


    useEffect(() => {
        const initialData = {};
        Object.values(annualAgrilcultureData).forEach(group => {
            Object.values(group.subGroups).forEach(subGroup => {
                Object.values(subGroup.itemCodes).forEach(item => {
                    initialData[item.itemCode] = {
                        itemCode: item.itemCode,
                        productionVolume: item.productionVolume,
                        productionValue: item.productionValue,
                        itemName: item.itemName

                    };
                });
            });
        });
        setItemData(initialData);
    }, [annualAgrilcultureData]);





    // handle textBox On change Event 
    const handleOnChange = async (indexId, field, newValue) => {

        if (!isNumeric(newValue)) {
            toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
            newValue = '0';
        }
        setItemData(prevItemData => {
            const updatedItemData = {
                ...prevItemData,
                [indexId]: {
                    ...prevItemData[indexId],
                    [field]: newValue,
                }
            };
            return updatedItemData;
        });
    }



    //handle save data
    const handleSaveAnnualAgricultureProductionData = async (e, buttonType) => {
        const customItemCodes = [];


        let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel) //button click status flag
        for (let item in itemData) {

            let itemCode = itemData[item].itemCode;
            let productionVolume = (parseFloat(itemData[item].productionVolume));
            let productionValue = (parseFloat(itemData[item].productionValue));
            let statusFlag = clickButtonStatusFlag;
            // let baseYear=yearName;
            const customObject = {
                itemSrno: itemCode,
                productionVolume: productionVolume,
                productionValue: productionValue,
                statusFlag: statusFlag,
                // baseYear:baseYear
            };
            customItemCodes.push(customObject);
        }


        let postData = {
            itemCodes: customItemCodes,
            payload: {
                Year: yearName,
                reportType: reportType,
                buttonType: buttonType,
                statusButtonFlag: clickButtonStatusFlag
            }
        };
        showLoading(true)
        try {

            const response = await axios.post(`${API_URL}api/iip/IIPAnnualAgriculturalProductionDataSaveToDB`, postData, config);
            if (response.data.status) {
                toast.success(response.data.message, messages.COLOR_RED);
                if (refreshAnnualAgricultureData) {
                    await refreshAnnualAgricultureData();
                }
            }
        } catch (error) {
            console.error(error);
            toast.error('An error occurred while processing your request.', messages.COLOR_RED);
        } finally {
            showLoading(false);
        }


    }
    //Reset Form all Data
    const resetForm = () => {
        resetFormData();
    }



    return (
        <>
            {/* <ToastContainer /> */}
            <div className="card-body">

                <div class="row">
                    <div class="d-flex justify-content-center">
                        <div class="col-md-8 mb-3">
                            <table class="table table-bordered">

                                {Object.values(annualAgrilcultureData).map(item => {

                                    return <React.Fragment>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '30%' }}>
                                                    <h6 class="mb-0">{item.majorGroupName}</h6>
                                                </th>
                                                <th style={{ width: '35%', textAlign: 'center' }}>Quantity</th>
                                                <th style={{ width: '35%', textAlign: 'center' }}>Values</th>
                                            </tr>
                                        </thead>

                                        {Object.values(item.subGroups).map(subGroup => {

                                            return <><tbody>
                                                <tr>
                                                    <th colspan="3">
                                                        <h6 class="mb-0 fw-bold"><b>{subGroup.subGroupName}</b></h6>
                                                    </th>
                                                </tr>
                                            </tbody>

                                                <>
                                                    {Object.values(subGroup.itemCodes).map((subItem, j) => {
                                                        return <>    <tbody>
                                                            <tr>
                                                                <td style={{ width: '30%' }}>{subItem.itemName}</td>
                                                                <td style={{ width: '35%' }}>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        name={`productionVolume_${subItem.itemCode}`}
                                                                        id={`productionVolume_${subItem.itemCode}`}
                                                                        maxLength="15"
                                                                        value={itemData[subItem.itemCode]?.productionVolume}
                                                                        onChange={e => handleOnChange(subItem.itemCode, 'productionVolume', e.target.value)} />
                                                                </td>
                                                                <td style={{ width: '35%' }}>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        name={`productionValue_${subItem.itemCode}`}
                                                                        id={`productionValue_${subItem.itemCode}`}
                                                                        maxLength="15"
                                                                        value={itemData[subItem.itemCode]?.productionValue}
                                                                        onChange={e => handleOnChange(subItem.itemCode, 'productionValue', e.target.value)} />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        </>;
                                                    })}

                                                </>
                                            </>

                                        })}

                                    </React.Fragment>

                                })}
                            </table>
                            <div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col-12 text-center pt-3">
                        {
                            <button
                                onClick={(e) => handleSaveAnnualAgricultureProductionData(e, 'SAVE')}
                                type="button"
                                className={`btn btn_orange mx-1 ${isSaveBtnDisable ? 'disabled' : ''}`}
                            >Save
                            </button>
                        }

                        {(userInfoObject.userLevel === 'HEAD QUARTER') &&
                            <>
                                <button
                                    onClick={(e) => handleSaveAnnualAgricultureProductionData(e, 'ACCEPT')}
                                    type="button"
                                    className={`btn btn_orange mx-1 ${isAcceptBtnDisable ? 'disabled' : ''}`}
                                >Accept
                                </button>
                                <button
                                    onClick={(e) => handleSaveAnnualAgricultureProductionData(e, 'REJECT')}
                                    type="button"
                                    className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
                                >Reject
                                </button>
                            </>

                        }

                        <button
                            type="reset"
                            className="btn btn_orange mx-1"
                            onClick={resetForm}
                        >
                            Reset
                        </button>
                        <button
                            type="button"
                            className="btn btn_orange mx-1"
                            onClick={(e) => (navigate("/dashboard"))}
                        >
                            Cancel
                        </button>
                    </div>
                </div>



            </div>
        </>
    )
}

export default AnnualAgriculturalProductionDetailsData